import Vue from 'vue';

const isClientError = (error) => {
  if (error 
    && error.response 
    && error.response.data 
    && error.response.data.response 
    && error.response.data.response.client_error_info 
    && error.response.data.response.error_code) {
     return true;
  }
  return false;
}

const airlockFlow = (error) => {
  if (error.response.data.response.client_error_info.airlock){
    return error.response.data.response.client_error_info.airlock.flow;
  }
  return null;
}

// When the request succeeds
const success = (response, context) => {
  
  context.loading = false;
  context.airbnbAccount.loading = false;

  if (response 
    && response.data.response 
    && response.data.response.filledAccountData 
    && response.data.response.filledAccountData.userId) {

    context.airbnbAccount.airbnbToken = response.data.response.token;
    context.airbnbAccount.airbnbUserId = response.data.response.filledAccountData.userId;
    context.user.onboarding_step = 8;
    context.next(context.user.onboarding_step);
    toastr.success(response.data.msg);
  
  }

};

// When the request fails
const failed = (error, context) => {

  if (isClientError(error)) {

    if (airlockFlow(error) === "captcha_flow") {

      context.airbnbAccount.randomDeviceId = error.response.data.randomDeviceId;
      context.user.onboarding_step = 99;
      context.next(99);

    } else if (airlockFlow(error) === 'account_ownership_verification_for_login') {

      context.airbnbAccount.randomDeviceId = error.response.data.randomDeviceId;
      context.next(6, error.response.data.response.client_error_info.airlock.id, error.response.data.response, error.response.data.response.client_error_info.airlock.friction_data);
    
    } else if (airlockFlow(error) === 'hard_block_message') {

      context.user.onboarding_step = 4;
      context.loading = false;
      toastr.error(context.$t('login.airbnb_hard_block'));
    
    } else if (error.response.data.response.error_code == 403) { // ----------------- CREDENTS ERROR
    
      context.user.onboarding_step = 4;
      context.loading = false;
      toastr.error(context.$t('login.wrong_credentials'));
    
    } else if (error.response.data.response.client_error_info.airlockV2) { // -------- AIRLOCKV2
    
      context.airlockData.airlock = error.response.data.response.client_error_info.airlockV2.id;
      context.airbnbUserIsV2 = true;
      context.next(0);
    
    }

  } else if (error
    && error.response && error.response.status == 400) {
    
    context.user.onboarding_step = 4;
    context.loading = false;
    if(error.response.data.msg && error.response.data.msg == 'duplicated') {
      toastr.error(context.$t('account.settings.user_platforms_section.duplicated_airbnb_account'));
    }
  
  } else if (error && error.data && error.data.status == "error" && error.status == 403) {
  
    context.user.onboarding_step = 4;
    context.loading = false;
    toastr.error(context.$t('login.wrong_credentials'));
  
  } else {
  
    context.user.onboarding_step = 4;
    context.loading = false;
    toastr.error(context.$t('rentals.detail.modals.something_went_wrong'));
  
  }

};

export default (context, account, user) => {
    const data = {
      account,
      randomDeviceId: context.airbnbAccount.randomDeviceId,
      email: user.email,
      user_id: user.id,
    };
    return  Vue.$http.post('/add-airbnb-account', data).then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed(response, context);
      }
    })
    .catch((error) => {
      failed(error,context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/createNewAirbnbAccount.js